"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const format_currency_1 = require("@App/helpers/format-currency");
const RightsholderRoyaltiesPayeeDownloadLink_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesPayeeDownloadLink"));
const RoyaltiesAnnualStatementsRow = (props) => {
    const { sendTSVRequest, payeeRoyalties } = props;
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", null, payeeRoyalties.publisherNumber),
        react_1.default.createElement("td", { className: 'bold' }, payeeRoyalties.payeeName),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'currency' },
                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(payeeRoyalties.openingBalanceAmount)))),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'currency' },
                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(payeeRoyalties.royaltiesAmount + payeeRoyalties.adjustmentsAmount)))),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'currency' },
                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(payeeRoyalties.payableBalanceAmount)))),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'currency' },
                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(payeeRoyalties.paymentAmount)))),
        react_1.default.createElement("td", null,
            react_1.default.createElement("div", { className: 'currency' },
                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(payeeRoyalties.closingBalanceAmount)))),
        react_1.default.createElement("td", null,
            react_1.default.createElement(RightsholderRoyaltiesPayeeDownloadLink_1.default, { payeeRoyalties: payeeRoyalties })),
        react_1.default.createElement("td", { className: 'no-right-border' },
            react_1.default.createElement("a", { className: 'small', onClick: () => sendTSVRequest(payeeRoyalties.ipId), href: '#' }, "Download"))));
};
exports.default = RoyaltiesAnnualStatementsRow;
